import { render, staticRenderFns } from "./AudiencePage.vue?vue&type=template&id=6abcc12d&scoped=true"
import script from "./AudiencePage.vue?vue&type=script&lang=js"
export * from "./AudiencePage.vue?vue&type=script&lang=js"
import style0 from "./AudiencePage.vue?vue&type=style&index=0&id=6abcc12d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abcc12d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abcc12d')) {
      api.createRecord('6abcc12d', component.options)
    } else {
      api.reload('6abcc12d', component.options)
    }
    module.hot.accept("./AudiencePage.vue?vue&type=template&id=6abcc12d&scoped=true", function () {
      api.rerender('6abcc12d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/AudiencePage.vue"
export default component.exports